import React from 'react';

const IconButton = ({ onClick, children, className = "btn sh_btniconnew" }) => {
  return (
    <a className={className} onClick={onClick} style={{ cursor: 'pointer' }}>
      {children}
    </a>
  );
};

export default IconButton;

